module.exports = __webpack_public_path__ + "assets/img/icon_next.ef5fe42b.svg";